/**
 * Documentos Legales API Service
 * Servicio para interactuar con la API de Documentos Legales y Flujo de Caja
 */

import api from './api';

// URL base para Contabilidad
const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const documentosLegalesService = {
  /**
   * Obtener Flujo de Caja
   * @param {string} fechaDesde - Fecha inicial (formato YYYY-MM-DD). Por defecto: hoy
   * @param {string} fechaHasta - Fecha final (formato YYYY-MM-DD). Por defecto: 30 días después
   * @param {string} tipoDocumento - Tipo de documento. Opcional
   * @param {string} estado - Estado del documento. Opcional
   * @param {string} vista - 'calendario' o 'resumen'. Por defecto: 'resumen'
   * @returns {Promise} - Datos del flujo de caja
   */
  getFlujoCaja: (fechaDesde = null, fechaHasta = null, tipoDocumento = null, estado = null, vista = 'resumen') => {
    const params = {};
    if (fechaDesde) params.fecha_desde = fechaDesde;
    if (fechaHasta) params.fecha_hasta = fechaHasta;
    if (tipoDocumento) params.tipo_documento = tipoDocumento;
    if (estado) params.estado = estado;
    params.vista = vista;

    return api.get(`${API_BASE_URL}/reportes/flujo-caja/`, { params });
  },

  /**
   * Cambiar estado de un documento
   * @param {number} documentoId - ID del documento
   * @param {string} nuevoEstado - Nuevo estado (emitida, pagada, vencida, anulada)
   * @returns {Promise}
   */
  cambiarEstado: (documentoId, nuevoEstado) => {
    return api.post(`${API_BASE_URL}/documentos-legales/${documentoId}/cambiar-estado/`, {
      nuevo_estado: nuevoEstado
    });
  },

  /**
   * Obtener documento por ID
   * @param {number} documentoId - ID del documento
   * @returns {Promise}
   */
  getById: (documentoId) => {
    return api.get(`${API_BASE_URL}/documentos-legales/${documentoId}/`);
  },

  /**
   * Listar documentos
   * @param {object} filters - Filtros opcionales
   * @returns {Promise}
   */
  getAll: (filters = {}) => {
    return api.get(`${API_BASE_URL}/documentos-legales/`, { params: filters });
  },

  /**
   * Contabilizar un documento (crear asiento contable)
   * @param {number} documentoId - ID del documento
   * @returns {Promise}
   */
  contabilizar: (documentoId) => {
    return api.post(`${API_BASE_URL}/documentos-legales/${documentoId}/contabilizar/`);
  }
};

export default documentosLegalesService;
